import { ASSET_LIBERARY_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const assetLiberaryInitialState = {
  data: [],
  assetLiberary: {},
  formError: null,
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function assetLiberaryReducer(
  state = assetLiberaryInitialState,
  action,
) {
  switch (action.type) {
    case ASSET_LIBERARY_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
